export let resolveIsPlayerReady:
    | ((value: PromiseLike<boolean> | boolean) => void)
    | null = null;
export let rejectIsPlayerReady: ((reason?: boolean) => void) | null = null;
export const isPlayReady = new Promise<boolean>((resolve, reject) => {
    resolveIsPlayerReady = resolve;
    rejectIsPlayerReady = reject;
});
